<template>
	<tag v-if="item?.delayedTill" class="blue" dark
		 :title="title"
		 active
		 @click.native.stop.prevent="showDialogTaskDelay(item)">{{ delayedTill }}
	</tag>
</template>

<script>

import base from "@/mixins/base";
import {mysql2DDMMYYYY} from "@/utils/date";
import {statuses} from "@/utils/task";

export default {
	name: "tag-delayed",
	mixins: [base],
	props: {
		item: {},
		small: {
			type: Boolean,
			default: false,
		}
	},
	data: () => ({}),
	computed: {
		title() {
			const status = statuses
				.find(status => typeof status.appliesTo === "function" && status.appliesTo({delayedTill: this.item.delayedTill}));
			if (status?.text) {
				return typeof status.text === "function" ? status.text(this.item) : status.text;
			}
			return null;
		},
		delayedTill() {
			return mysql2DDMMYYYY(this.item.delayedTill)?.substring(0, 5);
		},

		componentClass() {
			const c = [];
			if (this.mono) c.push("--mono");
			if (this.active) c.push("--active");

			return c.length ? c : null;
		},
	}
}
</script>

<style lang="scss">
.tag {
	position: relative;
	top: -1px;
	display: inline-block;
	/*font-size: $font-size-5;
	line-height: 100%;*/
	/*&.grey {
		background: map-get($grey, "lighten-2");
	}*/
	&.--mono {
		font-family: 'Courier New', Courier, monospace;
	}

	&.--active {
		//opacity: $default-hover-opacity;
		background-color: map-get($grey, "lighten-2");
		cursor: pointer;
		@include transition();

		&:hover {
			//opacity: 1;
			background-color: map-get($grey, "lighten-1");
		}
	}
}
</style>